// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_YF6TR","box":"index_box_KMhos","footer":"index_footer_1Miad"};